import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.STRINGS.CLINIC_NAME), 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.STRINGS.STREET) + ", " + _toDisplayString(_ctx.STRINGS.CITY), 1),
      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
      _cache[2] || (_cache[2] = _createTextVNode(" Tel. ", -1)),
      _createElementVNode("a", {
        href: `tel:${_ctx.STRINGS.PHONE_NUM}`
      }, _toDisplayString(_ctx.STRINGS.PHONE_NUM), 9, _hoisted_2),
      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
      _cache[4] || (_cache[4] = _createTextVNode(" E-Mail: ", -1)),
      _createElementVNode("a", {
        href: `mailto:${_ctx.STRINGS.EMAIL}`
      }, _toDisplayString(_ctx.STRINGS.EMAIL), 9, _hoisted_3)
    ])
  ]))
}